<template>
    <UiCard
        v-if="order && order.id"
        interactive
        class="ui-card--preview"
        @click="open"
    >
        <div class="ui-card__id">
            {{ order.id }}
        </div>
        <div class="ui-card__body py-2">
            <div v-if="order.user" class="ui-card__primary">
                {{ order.user.name }}
            </div>
            <div v-if="order.congress" class="ui-card__muted">
                {{ order.congress.title }}
            </div>
            <div class="mt-1">
                <StatusBadge :status="order.status" />
            </div>
        </div>
        <div class="ui-card__summary">
            <div class="ui-card__amount">
                {{ formatAmount(order.total_amount) }}
            </div>
            <div class="ui-card__muted">
                {{ dateHumanReadable(order.created_at) }}
            </div>
        </div>
    </UiCard>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { router } from '@inertiajs/vue3';
import { dateHumanReadable } from '@src/Common/Helpers/dates';
import StatusBadge from './StatusBadge.vue';

interface TicketOrder {
    id: number;
    uuid: string;
    status: string;
    total_amount: number;
    created_at: string;
    user?: {
        id: number;
        name: string;
    };
    congress?: {
        id: number;
        title: string;
    };
}

const props = defineProps<{
    order: TicketOrder;
}>();

const order = toRef(props, 'order');

const formatAmount = (amount: number): string => {
    return new Intl.NumberFormat('cs-CZ', {
        style: 'currency',
        currency: 'CZK',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
};

const open = (): void => {
    router.visit(route('congresses/ticket-orders.admin.edit', { id: order.value.id }));
};
</script>
